<template>
  <div class="body">
    <div class="title">
      名片管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>通讯录管理</el-breadcrumb-item>
          <el-breadcrumb-item>名片管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              v-model="mingpianQuery.create_date"
              @change="Discountsearch"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-cascader :props="checkedData.typeOptions" @change="changList" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="审核状态" v-model="mingpianQuery.verify_status" @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="未审核 "></el-option>
              <el-option  name="selected" :value="2" label="已审核 "></el-option>
              <el-option  name="selected" :value="3" label="拒绝 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="会员状态" v-model="mingpianQuery.is_status" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="下架 "></el-option>
              <el-option  name="selected" :value="2" label="上架 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " v-model="mingpianQuery.keyword"  @change="Discountsearch" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="400"
      :data="tableData"
      align="center"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="realname" title="姓名" width="100"></vxe-table-column>
      <vxe-table-column  title="头像" width="100">
        <template slot-scope="scope">
          <img :src="scope.row.user_facepic" alt="" style="width: 70px;height: 70px">
        </template>
      </vxe-table-column>
      <vxe-table-column  title="企业名称" width="100">
        <template slot-scope="scope">
          {{scope.row.com_name}}
        </template>
      </vxe-table-column>
      <vxe-table-column field="com_identity" title="身份" width="100"></vxe-table-column>
      <vxe-table-column field="hits" title="浏览人次" width="100"></vxe-table-column>
      <vxe-table-column field="follownum" title="关注者数" width="100"></vxe-table-column>
      <vxe-table-column  title="营业执照" width="150">
        <template slot-scope="scope">
          <img :src="scope.row.com_license" alt="" min-width="70" height="70"  :onerror="defaultImg">
        </template>
      </vxe-table-column>
      <vxe-table-column  title="名片状态" width="100">
        <template slot-scope="scope">
        <el-switch
          @change="sexChangeListOption(scope.row)"
          v-model="scope.row.shangjia"
          active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
        <span :style="{'color': (scope.row.is_status === 0 ? '#F7D05C':'#17ab3f')}">
            {{scope.row.is_status===1 ?'上架':'下架'}}
          </span>
      </template>
      </vxe-table-column>
      <vxe-table-column  title="置顶状态" width="250">
        <template slot-scope="scope">
          <el-switch
            disabled
            v-model="scope.row.zhiding"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <span :style="{'color': (scope.row.is_top === 0 ? '#F7D05C':'#17ab3f')}">
            {{scope.row.is_top===1 ?'付费置顶(剩余'+scope.row.istop_surplusdays+'天)':'未置顶'}}
          </span>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
          <div class="dsakgg">
            <!-- 修改按钮 -->
            <button class="huiyuananniu" @click="mingpianhuiyuanziliao(scope.row)">查看详情</button>
            <!-- 修改按钮 -->
            <button class="huiyuananniu" @click="huiyuanxiangqing(scope.row)">置顶记录</button>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal width="336" ref="shifoushangjia" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="plClose">
        <div class="titledd">
          是否确认{{itemcc.is_status===1?'下架':'上架'}}该明信片?
        </div>
        <div class="bobox">
          <button class="queren" @click="plqueren">
            确认
          </button>
          <button class="quxiao"  @click="plClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal v-model="dakaihuiyuanxiangqing" title="开通记录" width="1000" height="500" :mask="false" :lock-view="false" resize>
      <template #default>
        <div class="headetrxsadf">
          <div class="leftdsss">
            <div class="titleddss">
              {{zhidingjilu.realname}}
            </div>
          </div>
          <div class="right">
            <div class="huiyuanzhuangtai">
              置顶状态
              <span class="sadgggvv" v-if="zhidingjilu.is_top !==0 ">
               平台置顶付费置顶(剩余{{zhidingjilu.istop_surplusdays}}天)
              </span>
              <span class="sadccv" v-if="zhidingjilu.is_top ===0 ">
               未置顶
              </span>
            </div>
          </div>
        </div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="xTable"
          max-height="750"
          class="mytable-scrollbar"
          :data="zhidingjilu.top_pay"
          :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="paytime" title="置顶时间" width="100"></vxe-table-column>
          <vxe-table-column field="modular_name" title="置顶类型" width="100"></vxe-table-column>
          <vxe-table-column field="days" title="置顶时长/天" width="100"></vxe-table-column>
          <vxe-table-column field="paymoney" title="收费金额/元 " width="100"></vxe-table-column>
          <vxe-table-column field="pay_type" title="订单号" width="100"></vxe-table-column>
          <vxe-table-column field="order_no" title="第三方交易号" width="100"></vxe-table-column>
        </vxe-table>
      </template>
    </vxe-modal>
</div>
</template>

<script>
import { cardIstoprecord, cardlist, cardSetstatus } from '@/api/tongxunlu'
import { area, city, province } from '@/api/city'
export default {
  computed: {
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  name: 'mingpianguanli',
  data () {
    return {
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad
        }
      },
      mingpianQuery: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        verify_status: 0,
        com_provinceid: 0,
        com_cityid: 0,
        com_areaid: 0,
        is_status: 0,
        keyword: '',
        page: 1,
        pagesize: 10
      },
      total: null,
      cur_page: 1,
      pageshow: true,
      tableData: [],
      dakaihuiyuanxiangqing: false,
      itemcc: {},
      zhidingjilu: {}
    }
  },
  created () {
    this.list()
  },
  methods: {
    plClose () {
      this.$refs.shifoushangjia.close()
      this.Discountsearch()
    },
    plqueren () {
      if (this.itemcc.is_status === 1) {
        this.itemcc.is_status = 0
      } else {
        this.itemcc.is_status = 1
      }
      const obj = {
        token: sessionStorage.getItem('token'),
        card_id: this.itemcc.id,
        is_status: this.itemcc.is_status
      }
      cardSetstatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.shifoushangjia.close()
          this.Discountsearch()
        }
      })
    },
    sexChangeListOption (item) {
      console.log('row', item)
      this.itemcc = item
      this.$refs.shifoushangjia.open()
    },
    changList (val) {
      this.mingpianQuery.com_provinceid = val[0]
      this.mingpianQuery.com_cityid = val[1]
      this.mingpianQuery.com_areaid = val[2]
      this.Discountsearch()
    },
    async lazyLoad (node, resolve) {
      const level = node.level
      let result
      let res
      let param
      switch (level) {
        case 0: // 一级
          res = await province()
          result = res.data.list
          result.forEach((item) => {
            item.value = item.province_id
            item.label = item.province_name
          })
          break
        case 1: // 二级
          console.log(node.data.province_id)
          param = {
            province_id: node.data.province_id
          }
          res = await city(
            param
          )
          result = res.data.list
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id
            item.label = item.city_name
          })
          break
        case 2: // 三级目录
          console.log(node.data.city_id)
          param = {
            city_id: node.data.city_id
          }
          res = await area(
            param
          )
          result = res.data.list
          result.forEach((item) => {
            item.value = item.area_id
            item.label = item.area_name
            item.leaf = level >= 2
          })
          break
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = []
          break
      }
      console.log(result)
      resolve(result)
    },
    handleSizeChange (val) {
      this.mingpianQuery.pagesize = val
      this.handleCurrentChange(this.mingpianQuery.page)
    },
    handleCurrentChange (val) {
      this.mingpianQuery.page = val
      cardlist(this.mingpianQuery).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    Discountsearch () {
      this.cur_page = 1
      this.list()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    list () {
      cardlist(this.mingpianQuery).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
        this.tableData.forEach(i => {
          if (i.is_status === 0) {
            i.shangjia = false
          } else if (i.is_status === 1) {
            i.shangjia = true
          }
          if (i.is_top === 0) {
            i.zhiding = false
          } else if (i.is_top === 1) {
            i.zhiding = true
          }
        })
      })
    },
    huiyuanxiangqing (row) {
      this.dakaihuiyuanxiangqing = true
      const obj = {
        token: sessionStorage.getItem('token'),
        card_id: row.id
      }
      cardIstoprecord(obj).then(({ data: res }) => {
        console.log('resccc', res)
        if (res.result === 1) {
          this.zhidingjilu = res
        }
      })
    },
    mingpianhuiyuanziliao (row) {
      this.$store.commit('sethuiyuanID', row.id)
      this.$router.push('/huiyuanxiangqingchakan')
    }
  }
}
</script>

<style scoped lang="less">
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      flex: 1;
      margin-right: 150px;
      .btn{
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
        background: white;
      }
    }
    .right{
      margin-top: 27px;
    }
  }
  .huiyuananniu{
    background: white;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }
  .headetrxsadf{
    display:flex;
    flex-direction: row;
    height: 134px;
    align-items: center;
    .leftdsss{
      display:flex;
      flex-direction: row;
      align-items: center;
      flex:1;
      .titleddss{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        //text-align: left;
        color: #2e2e2e;
        .idss{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          //text-align: left;
          color: #2e2e2e;
        }
      }
    }
    .right{
      display:flex;
      flex-direction: row;
      align-items: center;
      .huiyuanzhuangtai{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #a1a1a1;
        margin-right: 8px;
        .sdadwee{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #e54848;
        }
        .sadgggvv{
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Heavy;
          font-weight: 800;
          text-align: left;
          color: #0FA838;
        }
      }
    }
  }
  .dsakgg{
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}
</style>
